// components/Loading.js
import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../pages/UserContext";

const Loading = () => {
  const { user } = useContext(UserContext); // Get user from UserContext
  const [settings, setSettings] = useState({
    shopName: "Shop Name",
    shopLogo: "",
  });
    const [isLoaded, setIsLoaded] = useState(false);
    const logoUrl = null;


  useEffect(() => {
    // Check if settings exist in local storage
    const cachedSettings = localStorage.getItem("shopSettings");
    
    if (cachedSettings) {
      setSettings(JSON.parse(cachedSettings)); // Load from local storage
    } else {
      // Fetch from API if not cached
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            const newSettings = {
              shopName: data.shop_name || "Shop Name",
              shopLogo: data.logo_white || "/assets/images/default-logo.png", // Default logo fallback
            };

            setSettings(newSettings);
            localStorage.setItem("shopSettings", JSON.stringify(newSettings)); // Save to local storage
          }
        })
        .catch((error) => {
          console.error("Error fetching settings:", error);
        });
    }
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white bg-opacity-90 z-50">
      <div className="flex flex-col items-center">
        {/* Golden Glow Animation */}
        <div className="relative">
          <div className="animate-ping absolute inline-flex h-16 w-16 rounded-full bg-yellow-500 opacity-75"></div>
          <div className="relative flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-yellow-100 to-white shadow-lg">
            {!isLoaded && (
        <img
          src="/assets/images/transparent.png"
          alt="Placeholder"
          className="w-50 h-50 absolute"
        />
      )}

      {/* Actual logo */}
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Logo"
          className="h-16 w-16 object-contain"
          style={{ visibility: isLoaded ? "visible" : "hidden" }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setIsLoaded(true)} // to prevent infinite placeholder if the image fails
        />
      )}
          </div>
        </div>

        {/* Loading Text */}
       {/* <p className="mt-6 text-yellow-300 text-lg font-semibold tracking-wide">
          Crafting Your Golden Experience...
        </p>  */}
      </div>
    </div>
  );
};

export default Loading;
